import { h } from "preact";
import { Checkbox, CheckboxIndicator } from "../../ui/checkbox/Checkbox";

const WidgetAsFee = ({
  quote,
  payer,
  onOpenModalClick,
  status,
  mode,
  alignment,
  variant,
  onToggleKeyDown,
  toggle,
  toggleHandler,
  getMessageForVoiceOver,
  onKeyDown,
  title,
}) => {
  return (
    <div
      className={mode === "dark" ? "pw-container dark-ui" : "pw-container"}
      data-container
    >
      <div className="pw-widget" data-widget>
        <div className="pw-row-1">
          <div className="left">
            <div
              className="pw-logo-container pw-logo-default"
              data-logo
              tabIndex="0"
            >
              <div className="default">
                {payer == "customer" && (
                  <Checkbox
                    checked={toggle == "true"}
                    onCheckedChange={toggleHandler}
                    data-testid="toggle"
                    role="checkbox"
                    aria-checked={toggle}
                    aria-live="polite"
                    id="speakerPower"
                    title={getMessageForVoiceOver(toggle == "true")}
                    aria-label={getMessageForVoiceOver(toggle == "true")}
                  >
                    <CheckboxIndicator />
                  </Checkbox>
                )}
              </div>
            </div>
            <div className="pw-title" onClick={toggleHandler}>
              <span data-title tabIndex="0">
                Sustainable Shipping Protection
              </span>

              <span data-mobile-title tabIndex="0">
                Green Shipping Protection
              </span>
            </div>

            <span
              className="pw-info-icon"
              onClick={onOpenModalClick}
              title="Learn more"
              alt="info icon"
              data-testid="pw-learn-more"
              data-trademark-learn-more
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 14 14"
                focusable="false"
                aria-hidden="true"
                class="a8x1wuu _1fragemoo _1fragempp _1fragemlt _1fragemlo"
              >
                <circle cx="7" cy="7" r="5.6"></circle>
                <path
                  strokeLinecap="round"
                  d="M7 10.111V7.1a.1.1 0 0 0-.1-.1h-.678"
                  fill="#6A6A6D"
                ></path>
                <circle cx="7" cy="4.2" r="0.4" fill="#6A6A6D"></circle>
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7.002 4.198h-.005v.005h.005z"
                  fill="#6A6A6D"
                ></path>
              </svg>
            </span>
          </div>
          <div className="pw-quote">{payer == "customer" ? quote : "FREE"}</div>
        </div>
      </div>
    </div>
  );
};

export default WidgetAsFee;
